var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("p", { staticClass: "mb-0 mt-3" }, [
        _c("strong", [
          _vm._v("\n            " + _vm._s(_vm.shop) + "\n        "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "loader-btn",
        {
          staticClass: "mx-auto my-3",
          attrs: {
            "loading-text": "Loading...",
            loading: _vm.isLoading,
            variant: "primary",
          },
          on: {
            click: function ($event) {
              return _vm.goToEtsyLink()
            },
          },
        },
        [_vm._v("\n        Reconnect my store\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }